// eslint-disable-next-line consistent-return
const invalidField = (value, type) => {
    switch (type) {
    case "email":
        return {
            fieldValid: (/\S+@\S+\.\S+/.test(value)),
            errorMessage: "Invalid email format",
        };
    case "phoneNumber":
        if (value !== "") {
            return {
                // eslint-disable-next-line no-useless-escape
                fieldValid: (/^\+?[0-9\s\-\(\)]{0,25}$/.test(value)),
                errorMessage: "Invalid phone number",
            };
        } 
        return {
            fieldValid: true,
            errorMessage: "",
        };
            
    case "orderNumber":
        return {
            fieldValid: (/^[0-9]{4,}$/.test(value)),
            errorMessage: "Invalid order number",
        };
    case "year":
        return {
            fieldValid: (/^[0-9]{4}$/.test(value)),
            errorMessage: "Field is Invalid",
        };
    default:
        break;
    }
};
export default invalidField;
